var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClaimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 15.3896H13.8677V17.7573C13.8677 18.0712 13.9924 18.3723 14.2144 18.5943C14.4364 18.8163 14.7376 18.9411 15.0515 18.9411C15.3655 18.9411 15.6666 18.8163 15.8886 18.5943C16.1106 18.3723 16.2353 18.0712 16.2353 17.7573V15.3896H18.603C18.9169 15.3896 19.218 15.2649 19.44 15.0429C19.6621 14.8209 19.7868 14.5198 19.7868 14.2058C19.7868 13.8918 19.6621 13.5907 19.44 13.3687C19.218 13.1467 18.9169 13.022 18.603 13.022H16.2353V10.6544C16.2353 10.3404 16.1106 10.0393 15.8886 9.81729C15.6666 9.59528 15.3655 9.47056 15.0515 9.47056C14.7376 9.47056 14.4364 9.59528 14.2144 9.81729C13.9924 10.0393 13.8677 10.3404 13.8677 10.6544V13.022H11.5001C11.1861 13.022 10.885 13.1467 10.663 13.3687C10.441 13.5907 10.3163 13.8918 10.3163 14.2058C10.3163 14.5198 10.441 14.8209 10.663 15.0429C10.885 15.2649 11.1861 15.3896 11.5001 15.3896V15.3896ZM25.7058 2.36768H4.39719C4.08323 2.36768 3.78212 2.4924 3.56011 2.71441C3.3381 2.93641 3.21338 3.23752 3.21338 3.55149V24.8601C3.21338 25.1741 3.3381 25.4752 3.56011 25.6972C3.78212 25.9192 4.08323 26.044 4.39719 26.044H25.7058C26.0198 26.044 26.3209 25.9192 26.5429 25.6972C26.7649 25.4752 26.8897 25.1741 26.8897 24.8601V3.55149C26.8897 3.23752 26.7649 2.93641 26.5429 2.71441C26.3209 2.4924 26.0198 2.36768 25.7058 2.36768V2.36768ZM24.522 23.6763H5.58101V4.7353H24.522V23.6763Z",
    fill: "#C5C5C5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIcon);
export default __webpack_public_path__ + "static/media/ClaimIcon.1bde4b47fbaa5ab6b81b89c09bff63fc.svg";
export { ForwardRef as ReactComponent };